angular
    .module('mainCarouselMenu.components', [])
    .component('mainCarouselMenu', {
        templateUrl: 'ng/components/mainCarouselMenu/mainCarouselMenu.html',
        bindings: {
            menuitemlist: '<',
            user: '=',
            homeico: '='
        },
        controllerAs: 'mainCarouselMenuCtrl',
        controller: function (
            $scope,
            FactoryObj,
            $configService,
            $rootScope,
            $download
        ) {

            $scope.goTo = $scope.$parent.goTo;

            $scope.changeActive = $scope.$parent.changeActive;

            this.$onInit = function () {
                $scope.userName = $configService.getUser().name;
                $scope.reteVendita = $configService.getUser().reteVendita;
                initializeMainCarouselMenu();

            }

            this.$onChanges = function (changed) {
                if (changed.menuitemlist && changed.menuitemlist.currentValue) {
                    initializeMainCarouselMenu();
                } else {
                    initializeMainCarouselMenu();
                }
                $rootScope.practiceId = null;
            }

            $scope.cleanFactoryObj = function () {
                FactoryObj.idAppSimulation = null;
                FactoryObj.origin = null;
                $rootScope.practiceId = null;
            }
            $scope.selectedIcon = function (item) {

                if (item.id === "trasparenza") {
                    window.open("https://www.albaleasing.eu/trasparenza", "_blank")
                }

                localStorage.setItem('IdIconSelected', item.id);
            }

            $scope.generateGuideDownloadLink = function (url) {

                $download.getGenericDownload(url)
                    .then(function (response) {
                        console.log(response);
                    })

            }
        }
    });